export enum InvitationErrorCode {
  INVITATION_PENDING = "INVITATION_PENDING",
  INVALID_TOKEN = "INVALID_TOKEN",
  SIGNEE_NOT_READY = "SIGNEE_NOT_READY",
  DOCUMENT_NOT_READY = "DOCUMENT_NOT_READY",
  SIGNEE_PENDING = "SIGNEE_PENDING",
  SIGNEE_FAILED = "SIGNEE_FAILED",
  SIGNEE_ALREADY_SIGNED = "SIGNEE_ALREADY_SIGNED",
  SIGNEE_REJECTED = "SIGNEE_REJECTED",
}
